import React, { Component } from "react"
import OutsideClickTrigger from "../common/OutsideClickTrigger"

class ParkingExtraServicesInfoModal extends Component {
  render() {
    const { extraProduct } = this.props
    if (!this.props.isActive || !extraProduct) return ""
    return (
      <div className="overlay overlay--modal overlay--fixed is-active">
        <div className="modal">
          <OutsideClickTrigger onOutsideClick={() => this.props.extraServiceModalInfoToogle(this.props.extraProduct)}>
            <button className="button button--icon js--close-modal" onClick={() => this.props.extraServiceModalInfoToogle(this.props.extraProduct)}>
              <span className="icon">
                <svg className="svg-icon svg-icon--close-new">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                    &nbsp;
                  </use>
                </svg>
              </span>
            </button>
            <div className="modal__content modal__content--no-padding">
              <div className="modal__content__inner">
                <div className="modal__top">
                  <header>
                    <h2>{extraProduct && extraProduct.dynamicFields && extraProduct.dynamicFields.productName}</h2>
                  </header>
                </div>
                <div className="modal__middle">
                  <p>
                    <span dangerouslySetInnerHTML={{ __html: extraProduct.longDescription }}></span>{" "}
                  </p>
                </div>
                <div className="modal__bottom" />
              </div>
            </div>
          </OutsideClickTrigger>
        </div>
      </div>
    )
  }
}
export default ParkingExtraServicesInfoModal
